export default "__VITE_ASSET__CbDUf1xA__"